import { render } from "./ReportsSidebar.vue?vue&type=template&id=0ba2a200&scoped=true"
import script from "./ReportsSidebar.vue?vue&type=script&lang=js"
export * from "./ReportsSidebar.vue?vue&type=script&lang=js"

import "./ReportsSidebar.vue?vue&type=style&index=0&id=0ba2a200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba2a200"]])

export default __exports__